<p>casinoProduct -- {{ casinoProduct }} categoryRoute -- {{ categoryRoute }} lobbyType --- {{ lobbyType }}</p>
<cc-casino-grid-on-lobby-type [lobbyType]="lobbyType" [categoryRoute]="categoryRoute"></cc-casino-grid-on-lobby-type>
